import { BaseFilterOption } from './types';
import { config as cancerKnowledgeBaseConfig } from './cancerKnowledgebase';
import { config as expressedGenesConfig } from './expressedGenes';
import { config as geneConfig } from './gene';
import { config as geneSetsConfig } from './geneSets';
import { config as outlierConfig } from './geneOutlier';
import { config as rnaConfig } from './rnaExpression';
import { config as selectedConfig } from './selected';

export const expressionOptions: Array<Partial<BaseFilterOption>> = [
  { ...selectedConfig },
  { ...geneSetsConfig },
  { ...geneConfig },
  { ...cancerKnowledgeBaseConfig },
  { ...rnaConfig },
  { ...expressedGenesConfig },
  { ...outlierConfig },
];
